import {
  PiggyBank,
  Star,
  GraduationCap,
  Brain,
  ShieldCheck
} from 'lucide-react';

// --- Enterprise Telemetry Constants ---
export const VCI_EVENTS = {
  // Micro-Actions
  APP_LOGIN: 10,
  // Core Actions
  USE_RESUME_GRADER: 75,
  USE_JOB_DISCOVERY: 50,
  USE_LONGEVITY_ANALYST: 100,
  COMPLETE_BUDGET_SIM: 100,
  COMPLETE_SURVIVAL_BUDGET: 150, 
  COMPLETE_PRO_PART: 50,
  INTEGRITY_BONUS: 25, 
  // Milestone Bonuses (B2B Refactored)
  EVALUATION_PHASE_COMPLETE: 500, // Was: COMPLETE_PRO_MODULE_FULL
  TOP_DECILE_ATS_VIABILITY: 250   // Was: SCORE_90_PLUS_RESUME
};

export const READINESS_TIERS = [
  { tier: 1, name: 'Tier 1: Baseline', minVCI: 0 },
  { tier: 2, name: 'Tier 2: Developing', minVCI: 500 },
  { tier: 3, name: 'Tier 3: Proficient', minVCI: 1200 },
  { tier: 4, name: 'Tier 4: Advanced', minVCI: 2500 },
  { tier: 5, name: 'Tier 5: Enterprise Ready', minVCI: 5000 },
];

export const VERIFIED_TRAITS = {
  'MACROECONOMIC_AWARENESS': { name: 'Macroeconomic Awareness', description: 'Mapped expectation delta to logistical reality.', icon: PiggyBank },
  'LOGISTICAL_ADAPTABILITY': { name: 'Logistical Adaptability', description: 'Stabilized baseline economics in high-friction market.', icon: ShieldCheck },
  'ATS_OPTIMIZATION': { name: 'ATS Optimization', description: 'Achieved 90+ viability against enterprise parsing algorithms.', icon: Star },
  'ENTERPRISE_COMMUNICATION': { name: 'Enterprise Communication', description: 'Verified proficiency in unwritten corporate protocols.', icon: GraduationCap },
  'AI_RESILIENCE': { name: 'AI Resilience', description: 'Executed verified human-in-the-loop risk audit.', icon: Brain },
};